/* Smells Plus — homepage interactivity: hero carousel, mobile drawer, FAQ accordion */
(function () {
  'use strict';

  /* ---------- Hero carousel ---------- */
  function initHero(root) {
    var track = root.querySelector('[data-sp-hero-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var count = slides.length;
    if (count <= 1) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sp-hero-dot]'));
    var counter = root.querySelector('[data-sp-hero-counter]');
    var index = 0;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-sp-interval'), 10) || 5000;
    var autoplay = root.getAttribute('data-sp-autoplay') !== 'false';

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function go(i) {
      index = (i + count) % count;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      if (counter) counter.textContent = pad(index + 1) + ' / ' + pad(count);
    }
    function next() { go(index + 1); }
    function prev() { go(index - 1); }
    function start() { if (autoplay) { stop(); timer = setInterval(next, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.querySelectorAll('[data-sp-hero-next]').forEach(function (b) {
      b.addEventListener('click', function () { next(); start(); });
    });
    root.querySelectorAll('[data-sp-hero-prev]').forEach(function (b) {
      b.addEventListener('click', function () { prev(); start(); });
    });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { go(di); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // basic touch swipe
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      startX = null; start();
    }, { passive: true });

    go(0);
    start();
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-sp-drawer]');
    var overlay = document.querySelector('[data-sp-drawer-overlay]');
    if (!drawer) return;
    function open() { drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

    document.querySelectorAll('[data-sp-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-sp-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    drawer.querySelectorAll('[data-sp-drawer-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('.sp-drawer__row');
        if (row) row.classList.toggle('is-open');
      });
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sp-faq-item]'));
    var single = root.getAttribute('data-sp-faq-single') !== 'false';
    items.forEach(function (item) {
      var q = item.querySelector('[data-sp-faq-q]');
      if (!q) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        if (single) items.forEach(function (i) { i.classList.remove('is-open'); });
        item.classList.toggle('is-open', !isOpen);
      });
    });
  }

  /* ---------- Quick add to cart ---------- */
  function updateCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-sp-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
        });
      })
      .catch(function () {});
  }

  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('[data-sp-quick-add]') : null;
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn && btn.disabled) return;
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '…'; }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (btn) {
            btn.innerHTML = res.ok ? '✓ Added' : '+ Add';
            setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1600);
          }
          if (res.ok) updateCartCount();
        })
        .catch(function () {
          if (btn) { btn.innerHTML = original; btn.disabled = false; }
          form.submit();
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-sp-hero]').forEach(initHero);
    document.querySelectorAll('[data-sp-faq]').forEach(initFaq);
    initDrawer();
    initQuickAdd();
    // keep the header cart count in sync with Dawn add-to-cart (product pages, etc.)
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, updateCartCount);
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify theme editor section load
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    el.querySelectorAll('[data-sp-hero]').forEach(initHero);
    el.querySelectorAll('[data-sp-faq]').forEach(initFaq);
    initDrawer();
  });
})();
